<template>
  <overlay-scrollbars :options="{ className: 'sidebar-content-container os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <div class="card">
      <dl>
        <dt>E-post</dt>
        <dd v-if="kunde.Email">
          <a :href="'mailto:' + kunde.Email">{{kunde.Email}}</a>
        </dd>
        <dd v-else>-</dd>

        <template v-if="kunde.Tlfprivat">
          <dt>Telefon privat</dt>
          <dd>{{kunde.Tlfprivat}}</dd>
        </template>
        <template v-if="kunde.Tlfarbeid">
          <dt>Telefon arbeid</dt>
          <dd>{{kunde.Tlfarbeid}}</dd>
        </template>
        <template v-if="kunde.Mobil">
          <dt>Mobil</dt>
          <dd>{{kunde.Mobil}}</dd>
        </template>

        <template v-if="sameAddress">
          <dt>Faktura- og leveringsadresse</dt>
          <dd v-if="adresseLevering">{{adresseLevering.full_address}}</dd>
          <dd v-else>-</dd>
        </template>
        <template v-else>
          <dt>Leveringsadresse</dt>
          <dd v-if="adresseLevering">{{adresseLevering.full_address}}</dd>
          <dd v-else>-</dd>

          <dt>Fakturaadresse</dt>
          <dd v-if="adresseFaktura">{{adresseFaktura.full_address}}</dd>
          <dd v-else>-</dd>
        </template>
        <dt><a href="javascript:;" @click="openAddressModal">Rediger adresse</a></dt>
        <dd></dd>
      </dl>
    </div>

    <div class="card" v-if="!hasAccess('consultant', true)">
      <table class="reporting">
        <tr>
          <td>
            <span class="title">
              <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object-sold"></use></svg> Solgte
            </span>
          </td>
          <td class="align-right">
            <span class="labels">
              <span class="label small gray" v-tippy :content="`<b>Sum vurdering:</b><br>Kr ${this.$options.filters.thousands(kunde.sum_objekt_seller || 0)}`">
                {{sumObjektSeller}}
              </span>
              <span class="label small" v-tippy :content="`<b>Sum tilslag:</b><br>Kr ${this.$options.filters.thousands(kunde.sum_objekt_seller_tilslag || 0)}`">
                {{sumObjektSellerTilslag}}
              </span>
            </span>
          </td>
          <td class="align-right">
            <span class="large">{{kunde.total_objekt_seller || 0}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="title">
              <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object-purchased"></use></svg> Kjøpte
            </span>
          </td>
          <td class="align-right">
            <span class="labels">
              <span class="label small gray" v-tippy :content="`<b>Sum vurdering:</b><br>Kr ${this.$options.filters.thousands(kunde.sum_objekt_buyer || 0)}`">
                {{sumObjektBuyer}}
              </span>
              <span class="label small" v-tippy :content="`<b>Sum tilslag:</b><br>Kr ${this.$options.filters.thousands(kunde.sum_objekt_buyer_tilslag || 0)}`">
                {{sumObjektBuyerTilslag}}
              </span>
            </span>
          </td>
          <td class="align-right">
            <span class="large">{{kunde.total_objekt_buyer || 0}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="title">
              <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object-returned"></use></svg> I retur
            </span>
          </td>
          <td class="align-right">
            <span class="labels">
              <span class="label small gray" v-tippy :content="`<b>Sum vurdering:</b><br>Kr ${this.$options.filters.thousands(kunde.sum_objekt_return || 0)}`">
                {{sumObjektReturn}}
              </span>
            </span>
          </td>
          <td class="align-right">
            <span class="large">{{kunde.total_objekt_return || 0}}</span>
          </td>
        </tr>
      </table>

      <dl>
        <dt>Registrert</dt>
        <dd>{{kunde.Registrert_dato | avantidatetime}}</dd>

        <dt>Sist endret</dt>
        <dd>{{kunde.Sist_endret_tid | avantidatetime}}</dd>

        <dt>Legitimasjon</dt>
        <dd class="overflow" v-if="kunde.legitimasjon">
          {{kunde.legitimasjon.Tekst}}
          <span class="logo">
            <span class="statusicon verified" v-if="kunde.Legitimert">
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg>
            </span>
            <span class="statusicon unverified" v-else>
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
            </span>
          </span>
        </dd>
        <dd class="overflow" v-else>-</dd>
      </dl>
    </div>

    <div><br></div>
    <!-- <div class="card">
      <dl>
        <dt>Kunsthandel</dt>
        <dd class="overflow" v-if="kunde.AktivertK">
          {{kunde.AktivertK | avantidatetime}}
          <span class="status green glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg> Samtykke</span>
        </dd>
        <dd class="overflow" v-else>
          Mangler samtykke
          <a class="button action small" @click="newsletter('AktivertK')">Send forespørsel</a>
        </dd>

        <dt>Nettauksjon</dt>
        <dd class="overflow" v-if="kunde.AktivertN">
          {{kunde.AktivertN | avantidatetime}}
          <span class="status green glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg> Samtykke</span>
        </dd>
        <dd class="overflow" v-else>
          Mangler samtykke
          <a class="button action small" @click="newsletter('AktivertN')">Send forespørsel</a>
        </dd>

        <dt>Vin</dt>
        <dd class="overflow" v-if="kunde.AktivertV">
          {{kunde.AktivertV | avantidatetime}}
          <span class="status green glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg> Samtykke</span>
        </dd>
        <dd class="overflow" v-else>
          Mangler samtykke
          <a class="button action small" @click="newsletter('AktivertV')">Send forespørsel</a>
        </dd>
      </dl>
    </div> -->
  </overlay-scrollbars>
</template>

<script>
import bus from '@/plugins/event-bus'
import Vue from 'vue'
import VueTippy from 'vue-tippy'

Vue.use(VueTippy, {
  directive: 'tippy',
  duration: 0,
  delay: 0,
  followCursor: false,
  arrow: true,
  animateFill: false,
  interactive: false,
  allowHTML: true,
  animation: 'fade',
  placement: 'left',
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: true
      }
    }
  }
})

export default {
  name: 'KundeCardSidebarTabProfile',
  data () {
    return {
      adresseFaktura: false,
      adresseLevering: false
    }
  },
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  created () {
    bus.$off('kunde-address-updated')

    this.adresseFaktura = this._.find(this.kunde.kundeadresse, ['Type', 'faktura']) || false
    this.adresseLevering = this._.find(this.kunde.kundeadresse, ['Type', 'levering']) || false
  },
  mounted () {
    bus.$on('kunde-address-updated', (data) => this.onKundeAddressUpdated(data))
  },
  watch: {
    'kunde.kundeadresse': function () {
      this.adresseFaktura = this._.find(this.kunde.kundeadresse, ['Type', 'faktura']) || false
      this.adresseLevering = this._.find(this.kunde.kundeadresse, ['Type', 'levering']) || false
    }
  },
  computed: {
    sumObjektSeller: function () {
      return this.numFormatter(this.kunde.sum_objekt_seller)
    },
    sumObjektSellerTilslag: function () {
      return this.numFormatter(this.kunde.sum_objekt_seller_tilslag)
    },
    sumObjektBuyer: function () {
      return this.numFormatter(this.kunde.sum_objekt_buyer)
    },
    sumObjektBuyerTilslag: function () {
      return this.numFormatter(this.kunde.sum_objekt_buyer_tilslag)
    },
    sumObjektReturn: function () {
      return this.numFormatter(this.kunde.sum_objekt_return)
    },
    sameAddress: function () {
      // Check if it is same address / for the checkbox
      if (this._.isEmpty(this.adresseLevering)) {
        return true
      }

      return this._.isEqual(this.adresseFaktura.full_address, this.adresseLevering.full_address)
    }
  },
  methods: {
    numFormatter: function (num) {
      return String(Intl.NumberFormat('nb-NO', { notation: 'compact', compactDisplay: 'short' }).format(Number(num) || 0)).replace(/,+/, '.')
    },
    onKundeAddressUpdated: function (data) {
      this.$helpers.showSuccessAlert('Kunde er lagret')

      bus.$emit('kunde-updated', data)
    },
    openAddressModal: function () {
      this.openModal(
        'kunde-adresse-modal',
        {
          kunde: this.kunde,
          event: 'kunde-address-updated'
        }
      )
    },
    newsletter: function (type) {
      alert('Ennå ikke implementert')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardSidebarTabProfile.vue